import { StringContext } from "../../core/StringContext";
import { StringModule } from "../../core/StringModule";
import { StringObject } from "../../objects/StringObject";

/**
 * The `StringAnchor` class extends the `StringModule` class and is responsible for
 * managing anchor-related functionality within the string module system.
 *
 * This class maps an `anchor` attribute to a tuple containing x and y coordinates,
 * processes these coordinates using the `originParser` tool, and applies the resulting
 * values to the connected object's element as a CSS `transform-origin` style.
 */
export class StringAnchor extends StringModule {
  constructor(context: StringContext) {
    super(context);
    this.htmlKey = "anchor";
    this.attributesToMap = [
      ...this.attributesToMap,
      {
        key: "anchor",
        type: "tuple",
        fallback: this.settings["anchor"],
        transform: (tuple: string[]) => {
          const [xRaw, yRaw] = tuple;
          const x = this.tools.originParser.process({ value: xRaw });
          const y = this.tools.originParser.process({ value: yRaw });
          return { x, y };
        },
      },
    ];
  }
  onObjectConnected(object: StringObject) {
    super.onObjectConnected(object);
    const anchor = object.getProperty<{ x: string; y: string }>("anchor");
    if (anchor) {
      this.applyToElementAndConnects(object, (el) => {
        el.style.transformOrigin = `${anchor.x} ${anchor.y}`;
      });
    }
  }
}
